import styles from "./Breadcrumb.module.css";

import { IconV2 } from "@/components/atoms/IconV2";
import { SkeletonV2 } from "@/components/atoms/Skeleton";

export interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
  loading?: boolean;
}

export interface Props {
  items: BreadcrumbItem[];
  "aria-label": string;
}

const renderLabel = (item: BreadcrumbItem, isCurrent: boolean) => {
  if (item.loading) {
    return (
      <SkeletonV2
        variant="text"
        surface="elev2"
        width={80}
        height={14}
        data-testid="breadcrumb-loading"
      />
    );
  }

  if (isCurrent) {
    return (
      <span className={styles.current} aria-current="page">
        {item.label}
      </span>
    );
  }

  if (item.onClick != null) {
    return (
      <button type="button" className={styles.link} onClick={item.onClick}>
        {item.label}
      </button>
    );
  }

  return <span className={styles.crumb}>{item.label}</span>;
};

export const Breadcrumb = ({ items, "aria-label": ariaLabel }: Props) => (
  <nav aria-label={ariaLabel}>
    <ol className={styles.list}>
      {items.map((item, index) => {
        const isCurrent = index === items.length - 1;
        // La posición es parte de la identidad del crumb (las etiquetas pueden
        // repetirse), así que la clave acumula las etiquetas hasta este nivel.
        const key = items
          .slice(0, index + 1)
          .map((crumb) => crumb.label)
          .join(" / ");

        return (
          <li key={key} className={styles.item}>
            {renderLabel(item, isCurrent)}
            {!isCurrent && (
              <IconV2
                name="chevronRight"
                size="s"
                className={styles.separator}
                aria-hidden
              />
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
